<script lang="ts" setup></script>
<template>
  <svg
    width="220"
    height="69"
    viewBox="0 0 220 69"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M80.4991 66.2168C77.7905 65.4425 76.2226 62.6192 76.9968 59.9106L84.3547 34.1674C85.129 31.4588 87.9523 29.8909 90.6604 30.6651C93.369 31.4394 94.9369 34.2622 94.1631 36.9708L86.8047 62.714C86.031 65.4226 83.2076 66.991 80.4991 66.2168Z"
    />
    <path
      d="M100.515 66.5365C98.4422 64.6292 98.3084 61.4025 100.216 59.3294L116.15 42.0183L119.902 45.4721C121.975 47.3795 122.108 50.6062 120.201 52.6788L107.722 66.2375C105.814 68.3106 102.587 68.4439 100.515 66.5365Z"
    />
    <path
      d="M139.869 66.5365C141.942 64.6292 142.076 61.4025 140.168 59.3294L124.235 42.0183L118.811 47.0096C117.661 48.0683 117.587 49.8584 118.645 51.0085L132.662 66.2375C134.57 68.3106 137.797 68.4439 139.869 66.5365Z"
    />
    <path
      d="M76.2292 9.863L76.2397 9.8021C76.5687 7.83034 78.4341 6.49852 80.4064 6.82798L91.8002 8.73136C93.7725 9.06082 95.1043 10.9263 94.7743 12.8985L94.7643 12.9594C94.4349 14.9312 92.5694 16.2625 90.5972 15.9335L79.2034 14.0302C77.2316 13.7002 75.8998 11.8348 76.2292 9.863Z"
    />
    <path
      d="M103.6 22.2601L103.299 22.2097C100.649 21.7674 98.8604 19.2605 99.3031 16.6109L101.378 4.18928C101.82 1.53963 104.327 -0.249431 106.977 0.192843L107.278 0.243261C109.927 0.686034 111.716 3.19292 111.274 5.84207L109.198 18.2642C108.756 20.9133 106.249 22.7029 103.6 22.2601Z"
    />
    <path
      d="M135.384 22.3147C132.651 21.8579 130.806 19.2727 131.263 16.5402L132.043 11.8673C132.5 9.13482 135.085 7.28935 137.817 7.7461C140.55 8.20235 142.395 10.7876 141.939 13.5206L141.158 18.1934C140.702 20.926 138.117 22.7714 135.384 22.3147Z"
    />
    <path d="M137.72 13.3041H107.769V7.81315H137.72V13.3041Z" />
    <path
      d="M119.999 51.741C116.828 51.741 114.258 49.1712 114.258 46.0005V28.5291C114.258 25.3588 116.828 22.7886 119.999 22.7886C123.17 22.7886 125.739 25.3588 125.739 28.5291V46.0005C125.739 49.1712 123.17 51.741 119.999 51.741Z"
    />
    <path
      d="M155.109 65.7073C153.083 63.3841 153.325 59.8584 155.649 57.8337L166.215 48.6239C168.539 46.5992 172.065 46.8408 174.089 49.1645C176.115 51.4882 175.873 55.0134 173.549 57.0391L162.983 66.2479C160.659 68.2731 157.134 68.031 155.109 65.7073Z"
    />
    <path
      d="M210.101 8.31232H159.684C158.305 8.31232 157.188 7.19465 157.188 5.81641C157.188 4.43818 158.305 3.32051 159.684 3.32051H210.101C211.48 3.32051 212.597 4.43818 212.597 5.81641C212.597 7.19465 211.48 8.31232 210.101 8.31232Z"
    />
    <path
      d="M216.59 31.2746H153.693C152.315 31.2746 151.198 30.1569 151.198 28.7787C151.198 27.4005 152.315 26.2828 153.693 26.2828H216.59C217.969 26.2828 219.086 27.4005 219.086 28.7787C219.086 30.1569 217.969 31.2746 216.59 31.2746Z"
    />
    <path
      d="M216.341 66.7164H198.869C197.353 66.7164 196.124 65.4869 196.124 63.9709C196.124 62.4549 197.353 61.2254 198.869 61.2254H216.341C217.857 61.2254 219.086 62.4549 219.086 63.9709C219.086 65.4869 217.857 66.7164 216.341 66.7164Z"
    />
    <path
      d="M198.959 66.7164H197.781C194.936 66.7164 192.629 64.4097 192.629 61.5644V31.934C192.629 29.0887 194.936 26.782 197.781 26.782H198.959C201.804 26.782 204.111 29.0887 204.111 31.934V61.5644C204.111 64.4097 201.804 66.7164 198.959 66.7164Z"
    />
    <path
      d="M169.917 56.2336C166.746 56.2336 164.176 53.6639 164.176 50.4931V33.0217C164.176 29.8514 166.746 27.2812 169.917 27.2812C173.088 27.2812 175.657 29.8514 175.657 33.0217V50.4931C175.657 53.6639 173.088 56.2336 169.917 56.2336Z"
    />
    <path
      d="M4.59836 24.3114C1.86585 23.8546 0.0203762 21.2694 0.477126 18.5369L2.75938 4.87279C3.21613 2.13978 5.80139 0.294806 8.5339 0.751057C11.2664 1.20781 13.1119 3.79306 12.6551 6.52558L10.3729 20.1902C9.91613 22.9227 7.33088 24.7681 4.59836 24.3114Z"
    />
    <path
      d="M30.6071 66.6082L30.4294 66.5198C27.7184 65.1716 26.6137 61.8815 27.962 59.1709L31.8935 50.7427C33.2413 48.0317 37.9755 44.5464 40.6861 45.8942L40.8643 45.9831C43.5749 47.3308 44.6795 50.6209 43.3318 53.3315L37.9561 64.1412C36.6083 66.8513 33.3177 67.956 30.6071 66.6082Z"
    />
    <path
      d="M20.073 24.3114C17.3405 23.8546 15.495 21.2694 15.9517 18.5369L16.7325 13.864C17.1887 11.1315 19.774 9.28605 22.5065 9.7428C25.2395 10.1991 27.0845 12.7843 26.6277 15.5173L25.8475 20.1902C25.3907 22.9227 22.8055 24.7681 20.073 24.3114Z"
    />
    <path d="M22.9082 15.3009H8.93115V9.80992H22.9082V15.3009Z" />
    <path
      d="M11.427 63.7214C8.3945 63.7214 5.93604 61.2629 5.93604 58.2304V33.7705C5.93604 30.738 8.3945 28.2795 11.427 28.2795C14.4595 28.2795 16.918 30.738 16.918 33.7705V58.2304C16.918 61.2629 14.4595 63.7214 11.427 63.7214Z"
    />
    <path
      d="M15.9196 56.2337C15.9196 56.2337 19.4139 52.7394 21.9098 53.2386C24.4057 53.7377 23.9065 56.7328 23.4074 57.232C22.9082 57.7312 11.9262 64.2205 11.9262 64.2205C11.9262 64.2205 9.4303 64.7197 7.93276 63.7214C6.43522 62.723 5.93604 62.2238 5.93604 59.2287C5.93604 56.2337 15.9196 56.2337 15.9196 56.2337Z"
    />
    <path
      d="M35.8869 13.8033C35.8869 13.8033 32.8918 10.309 32.3926 7.31395C31.8934 4.31887 32.8918 1.32378 35.8869 0.824603C38.8819 0.325422 39.8803 1.32378 41.3778 3.81969C42.8754 6.31559 44.8721 12.3058 44.8721 12.3058V15.3008L36.386 14.8017L35.8869 13.8033Z"
    />
    <path
      d="M59.3483 13.8033C59.3483 13.8033 62.3434 10.309 62.8426 7.31395C63.3417 4.31887 62.3434 1.32378 59.3483 0.824603C56.3532 0.325422 55.3548 1.32378 53.8573 3.81969C52.3598 6.31559 50.363 12.3058 50.363 12.3058V15.3008L58.8491 14.8017L59.3483 13.8033Z"
    />
    <path
      d="M64.3403 16.7984H31.3943C30.0161 16.7984 28.8984 15.6807 28.8984 14.3025C28.8984 12.9243 30.0161 11.8066 31.3943 11.8066H64.3403C65.7185 11.8066 66.8362 12.9243 66.8362 14.3025C66.8362 15.6807 65.7185 16.7984 64.3403 16.7984Z"
    />
    <path
      d="M64.3402 39.7607H29.3975C28.0193 39.7607 26.9016 38.6435 26.9016 37.2648C26.9016 35.886 28.0193 34.7689 29.3975 34.7689H64.3402C65.7184 34.7689 66.8361 35.886 66.8361 37.2648C66.8361 38.6435 65.7184 39.7607 64.3402 39.7607Z"
    />
    <path
      d="M57.1022 68.214C53.9319 68.214 51.3616 65.6442 51.3616 62.4734V18.0463C51.3616 14.876 53.9319 12.3058 57.1022 12.3058C60.2724 12.3058 62.8427 14.876 62.8427 18.0463V62.4734C62.8427 65.6442 60.2724 68.214 57.1022 68.214Z"
    />
    <path
      d="M43.8736 50.7427H31.8933V18.1701C31.8933 14.931 34.5185 12.3058 37.7577 12.3058H38.0093C41.2485 12.3058 43.8736 14.931 43.8736 18.1701V50.7427Z"
    />
  </svg>
</template>
